import { render, staticRenderFns } from "./HomeIndex.vue?vue&type=template&id=127dfe46&scoped=true"
import script from "./HomeIndex.vue?vue&type=script&lang=js"
export * from "./HomeIndex.vue?vue&type=script&lang=js"
import style0 from "./HomeIndex.vue?vue&type=style&index=0&id=127dfe46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127dfe46",
  null
  
)

export default component.exports